var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6693 1.89057V5.33268C11.6693 5.79939 11.6693 6.03275 11.7601 6.21101C11.84 6.36781 11.9675 6.49529 12.1243 6.57519C12.3025 6.66602 12.5359 6.66602 13.0026 6.66602H16.4447M16.6693 8.32287V14.3327C16.6693 15.7328 16.6693 16.4329 16.3968 16.9677C16.1571 17.4381 15.7747 17.8205 15.3042 18.0602C14.7695 18.3327 14.0694 18.3327 12.6693 18.3327H7.33594C5.93581 18.3327 5.23574 18.3327 4.70096 18.0602C4.23056 17.8205 3.8481 17.4381 3.60842 16.9677C3.33594 16.4329 3.33594 15.7328 3.33594 14.3327V5.66602C3.33594 4.26588 3.33594 3.56582 3.60842 3.03104C3.8481 2.56063 4.23056 2.17818 4.70096 1.9385C5.23574 1.66602 5.93581 1.66602 7.33594 1.66602H10.0124C10.6239 1.66602 10.9296 1.66602 11.2173 1.73509C11.4724 1.79633 11.7163 1.89734 11.94 2.03442C12.1923 2.18902 12.4085 2.40521 12.8408 2.83759L15.4977 5.49444C15.9301 5.92682 16.1463 6.14301 16.3009 6.3953C16.4379 6.61898 16.539 6.86285 16.6002 7.11794C16.6693 7.40565 16.6693 7.71139 16.6693 8.32287Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.40f4acaf96505b82688ce3bbc2d98354.svg";
export { ForwardRef as ReactComponent };